import script from "./DiscoverySelection.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoverySelection.vue?vue&type=script&setup=true&lang=js"

import "./DiscoverySelection.vue?vue&type=style&index=0&id=b58ed09a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b58ed09a"]])

export default __exports__